import { AgentCustomLinkDetailsResponse, OwlError } from '@insurgrid/common';
import { useQuery } from '@tanstack/react-query';
import { useParams, useSearchParams } from 'next/navigation';
import { useClient } from './useClient';
import { owlClient } from '../../apiUtils/client';
import { QueryKey } from '../../types';

export function useCustomLink() {
  const { client } = useClient();
  const query = useSearchParams();
  const params = useParams();
  const customLinkSlug = query?.get('customLink');
  const agentId = params?.agentSlug;

  const {
    data: customLink,
    error: customLinkError,
    isLoading: customLinkLoading,
    isInitialLoading,
  } = useQuery<AgentCustomLinkDetailsResponse, OwlError>(
    [QueryKey.CustomLink],
    () =>
      owlClient.agent.getCustomLinkDetails({
        args: {
          agentId: agentId as string,
          customLinkSlug: customLinkSlug as string,
        },
      }),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      onError: console.log,
      enabled: !!customLinkSlug && !!agentId,
    },
  );

  const customLinkData = client?.data.customLink ?? customLink?.data;
  const referralCompanyInfoExists =
    !!customLinkData?.referralPartnerCompany ||
    !!customLinkData?.referralPartnerLogoUrl;

  const referralPartnerInfoExists =
    !!customLinkData?.referralPartnerName ||
    !!customLinkData?.referralPartnerLogoUrl;

  const customLinkClosed = customLinkError?.response?.status === 410;

  return {
    customLink: customLinkData,
    customLinkLoading: isInitialLoading ?? customLinkLoading,
    customLinkClosed,
    customLinkUnavailable: customLinkClosed && !client?.data.customLink,
    referralEnabled:
      (referralPartnerInfoExists && referralCompanyInfoExists) ||
      referralCompanyInfoExists,
  };
}
